import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CsvUploadService } from "../../../services/csv-upload.service";
import { IOption } from "ng-select";
import { Loggerservice } from "../../../services/logger-service";
import { Router } from "@angular/router";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: "app-country-master",
  templateUrl: "./country-master.component.html"
})
export class CountryMasterComponent implements OnInit {
  disablestatus = false;
  nameExist1 = false;
  previousData: any = [];
  rejected = 0;
  data_present = false;
  minRemark = false;
  exceedLength1 = false;
  minlength1 = false;
  notAlphabet1 = false;
  onlyspaces = false;
  isApproved = false;
  CUR_ID;
  CUR_NAME;
  auto_msg;
  currency_details: any = [];
  hide = false;
  gotoChangeStatus = true;
  approveStatus;
  aprvbtn = false;
  updateApprove = false;
  forupdate = false;
  formstatusdata = [];
  currencydata = [];
  autoArray: any = [];
  like = "COUNTRY_NAME";
  myOptions: Array<IOption> = this.autoArray;

  mincityname = false;
  offSubmit = false;

  searchresult = false;
  onlynum = false;
  cnameExceed = false;
  invalidCityName = false;
  minlength = false;
  notAlphabet = false;
  exceedLength = false;
  //**** */
  ccode1;
  ccode2;
  ccode3;
  validatorArray: any = [];

  //** */
  results: string[];

  countries: any[];
  filteredResponseList: any = [];
  parentTableName = "mst_country"; //insert table name
  searchDBColumnName = "COUNTRY_NAME";
  searchDBColumnCurrency = ["CURRENCY_ID", "CURRENCY_NAME"];
  //insert required column name
  //**** */
  searchlist: boolean = true;
  showApprove = false;
  viewPageDetails = [];
  viewpage = false;
  dblclick = false;
  loader: any = false;
  nameExist = false;
  showList: boolean = false;

  countrycodepatrn = "^[A-Z]{2}$";
  screentitle: string = "Country Master";
  actionmode: string = "Seacrh";
  parent_table = "mst_country";
  parent_table_ID = "COUNTRY_ID";
  COUNTRY_CODE = "COUNTRY_CODE";
  COUNTRY_NAME = "COUNTRY_NAME";
  Parent_result_ID = "";
  APPROVAL_STATUS = "APPROVAL_STATUS";
  onlyspclchar = false;
  dbFields = [
    this.COUNTRY_CODE,
    this.COUNTRY_NAME,
    this.APPROVAL_STATUS,
    "STATUS",
    "CURRENCY_ID"
  ];
  dbField = [this.COUNTRY_CODE, this.COUNTRY_NAME, "CURRENCY_ID"];
  searchitem = " ";
  searchColumn = " ";
  childtables = ["mst_currency"];
  filters = ["CURRENCY_ID"];
  screen_details: any = [];
  search_details: any = [];
  serachtabledata: any = [];
  data: any = [];
  status: any = {};
  sortType = "";
  p: number = 1;
  codePattern = "^[A-Z]{1,3}$";
  namePattern =
    "^^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$";

  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  roleID = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  fid = "";
  // count1 = 0;
  // count2 = 0;
  constructor(
    private vernostService: VernostServiceService,
    private csvupload: CsvUploadService,
    private logService: Loggerservice,
    private commonService : CommonService,
    private router: Router

  ) {}

  ngOnInit() {
    this.getCurrency();
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    let rollArrayCountryMaster = {
      funId: this.fid,
      roleID: this.roleID
    };

    this.vernostService.checkFunAccess(rollArrayCountryMaster).subscribe(resp => {
      this.RAC_VIEW = JSON.stringify(resp[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(resp[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(resp[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(resp[0].addinfo[0].RAC_APROVE);
    });
    this.screen_details = {
      COUNTRY_CODE: "",
      COUNTRY_NAME: "",
      CURRENCY_ID: "0"
    };
    this.search_details = {
      COUNTRY_CODE: "",
      COUNTRY_NAME: ""
    };
    this.aprove_details = {
      APPROVAL_REMARKS: ""
    };
    this.showList = false;
    this.uid = localStorage.getItem("uid");
    this.vernostService.getValidator().subscribe(res => {
      this.validatorArray = res;
      this.ccode1 = this.validatorArray.City_Master.City_Code[1];
      this.ccode2 = this.validatorArray.City_Master.City_Code[2];
      this.ccode3 = this.validatorArray.City_Master.City_Code[3];
    });
  }

  checkAproval() {
    // this.aprovebtn="";
    var dbField = [this.APPROVAL_STATUS];
    let arrayCountryMaster = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrayCountryMaster).subscribe(response => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  getCurrency() {
    this.vernostService.getCurrency().subscribe(response => {
      this.currency_details = response;
    });
  }

  changeName() {
    let dataCountryMaster = {
      parent_table: this.parent_table,
      formData: this.Parent_result_ID,
      columnName: "COUNTRY_ID"
    };

    this.vernostService.getSTATUS(dataCountryMaster).subscribe(response => {
      this.approveStatus = response[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

  gotochangestatus() {
    if (this.actionmode == "Edit") {
      var data = {
        parent_table: this.parent_table,
        formData: this.Parent_result_ID,
        columnName: this.parent_table_ID
      };

      this.vernostService.editstatus(data).subscribe(response => {
        //   alert(response);
        this.isApproved = false;
      });
    }
  }

  checkNames1() {
    if (
      this.screen_details.COUNTRY_NAME != undefined &&
      this.screen_details.COUNTRY_NAME != ""
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "COUNTRY_NAME",
          dbFieldName: this.screen_details.COUNTRY_NAME,
          parent_table: this.parent_table
        };

        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist1 = false;
            if (this.offSubmit) {
              this.submitdata();
            }
          } else {
            this.nameExist1 = true;
          }
        });
      }
    }
  }


  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'country-master');
  }

  aproveReject(status) {
    if (!this.nameExist1) {
      this.isApproved = true;
      let currentTime = new Date();

      var dbFieldCountryMaster = [
        this.APPROVAL_STATUS,
        this.APPROVAL_REMARKS,
        this.APPROVAL_BY,
        "STATUS",
        "APPROVAL_DATE_TIME"
      ];
      if (status == 1) {
        this.approveStatus = 1;
      }
      var formDataCountryMaster = [
        status,
        this.aprove_details.APPROVAL_REMARKS,
        this.uid,
        status,
        currentTime
      ];
      var array = {
        dbField: dbFieldCountryMaster,
        parent_table: this.parent_table,
        formData: formDataCountryMaster,
        parent_table_ID: this.parent_table_ID,
        formdataId: this.Parent_result_ID
      };

      this.vernostService.aproveReject(array).subscribe(response => {
        this.aprove_details.APPROVAL_REMARKS = "";
        if (status == 2) {
          this.rejected = 2;

          this.logService.create_log_masters(
            "'Component Name':Country Master,'Action':Reject Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Record':" +
              JSON.stringify(this.screen_details),
            "info"
          );
        } else {
          if (this.isApproved && this.actionmode == "Edit") {
            this.checkColor();
          }

          if (response[0].aproval == "aproved") {
            this.aprvbtn = false;

            this.logService.create_log_masters(
              "'Component Name':Country Master,'Action':Approve Record,'Modified by':" +
                localStorage.getItem("fname") +
                "'Record':" +
                JSON.stringify(this.screen_details),
              "info"
            );
          }
          this.aprvbtn = false;
          // if (response[0].aproval == "rejected") {
          //   this.aprvbtn = false;
          //   this.aprovebtn=false;
          //   this.searchForm();
          // } else {
          //   this.aprvbtn = false;
          //   this.rejectbtn=false;
          //   this.searchForm();
          // } 
        }
        if (this.actionmode == "Edit") {
          this.submitData1();
        }
        this.searchData();
      });
    }
  }
  setId(id) {
    this.Parent_result_ID = id;
  }

/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

 /* changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } else if (status == 0) {
      status = 1;
    }

    let dataCountryMaster = {
      parent_table: this.parent_table,
      formData: id,
      columnName: "COUNTRY_ID",
      status: status
    };

    this.vernostService.changeSTATUS(dataCountryMaster).subscribe(res => {
      this.searchData();
    });
  } */

  /*
  sortByOrder(data, number_country) {
    if (number_country == 1) {
      if (this.count1 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count1++;
      this.count2 = 0;
    }
    if (number_country == 2) {
      if (this.count2 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count2++;
      this.count1 = 0;
    }
    var arrayCountryMaster = {
      sortField: data,
      parent_table: this.parent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.sortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };

    this.vernostService.sortByOrder(arrayCountryMaster).subscribe(resp => {
      this.serachtabledata = resp;
    });
  } */

  addForm() {
    this.rejected = 0;
    this.onlyspclchar = false;
    this.exceedLength1 = false;
    this.notAlphabet1 = false;
    this.updateApprove = false;
    this.search_details = {
      COUNTRY_CODE: "",
      COUNTRY_NAME: ""
    };
    this.screen_details = {
      COUNTRY_CODE: "",
      COUNTRY_NAME: "",
      CURRENCY_ID: "0"
    };
    this.showList = false;
    this.Parent_result_ID = "";
    this.actionmode = "Add";
    this.aprove_details = {
      APPROVAL_REMARKS: ""
    };

    this.mincityname = false;

    this.onlynum = false;
    this.cnameExceed = false;
    this.invalidCityName = false;
    this.minlength = false;
    this.notAlphabet = false;
    this.exceedLength = false;
    this.forupdate = false;
    this.nameExist = false;
    this.nameExist1 = false;
    document.getElementById("errs").innerHTML = "";
  }
  openfileDialog() {
    document.getElementById("fileLoader").click();
  }

  searchForm() {
    this.rejected = 0;
    if (this.actionmode != "Edit") {
      this.searchData();
    } else {
      this.search_details.COUNTRY_CODE = "";
      this.search_details.COUNTRY_NAME = "";
      this.searchresult = false;
    }

    this.screen_details = {
      COUNTRY_CODE: "",
      COUNTRY_NAME: ""
    };
    this.actionmode = "Search";
    this.viewpage = false;
    this.showList = false;
    this.showApprove = false;

    this.mincityname = false;

    this.onlynum = false;
    this.cnameExceed = false;
    this.invalidCityName = false;
    this.minlength = false;
    this.notAlphabet = false;
    this.exceedLength = false;
    this.nameExist = false;
    this.nameExist1 = false;

    // this.searchData();
    // if (this.forupdate) {
    //   document.getElementById("errs").innerHTML = "Record updated Successfully";

    //   setTimeout(function() {
    //     document.getElementById("errs").innerHTML = "";
    //     document.getElementById("errs").style.background = "#ebccd1";
    //     document.getElementById("errs").style.color = "#a94442";
    //   }, 3000);
    // }
    document.getElementById("errs").innerHTML = "";
  }
  showFormData(formData, toggle, status, approvestatus) {
    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";
      if (status == 0 && approvestatus == 0) {
        this.isApproved = false;
      }
      if (approvestatus == 1) {
        this.isApproved = true;
      }
    }
    this.Parent_result_ID = formData;

    let arrayCountryMaster = {
      parent_table: this.parent_table,
      dbFields: this.dbFields,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
    this.vernostService.getData(arrayCountryMaster).subscribe(response => {
      this.screen_details = {
        COUNTRY_CODE: response[0].result[0].COUNTRY_CODE,
        COUNTRY_NAME: response[0].result[0].COUNTRY_NAME,
        CURRENCY_ID: response[0].result[0].CURRENCY_ID
      };
      //alert(JSON.stringify(this.screen_details));
      // screen_details.COUNTRY_NAME

      this.viewPageDetails = response[0].result;
      this.previousData = response[0].result;
      this.approveStatus = response[0].result[0].STATUS;

      if (toggle == "1") {
        this.actionmode = "Add";
        this.checkAproval();

        this.viewpage = true;

        this.actionmode = "Add";
        if (!this.showApprove) {
          this.showList = true;
        } else {
          this.showList = false;
        }

        var parent_table = "mst_country";
        var childtables = ["mst_currency"];
        var datalike = ["CURRENCY_ID"];
        var dbFields = ["CURRENCY_CODE,CURRENCY_NAME"];
        var findData = [this.screen_details.CURRENCY_ID];

        var data = {
          parent_table: parent_table,
          childtables: childtables,
          datalike: datalike,
          dbFields: dbFields,
          findData: findData
        };

        this.vernostService.searchRecordById(data).subscribe(searchResponse => {
          var f1 = searchResponse[0];
          this.CUR_ID = f1[0].CURRENCY_CODE;
          this.CUR_NAME = f1[0].CURRENCY_NAME;
        });
      }
      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }

  submitdata() {
    this.dblclick = true;
    this.offSubmit = false;
    if (
      this.screen_details.COUNTRY_CODE == "" ||
      this.screen_details.COUNTRY_NAME == "" ||
      this.screen_details.CURRENCY_ID == ""
    ) {
      // alert("Please fill all the Field");
      document.getElementById("errs").innerHTML = "Please fill all data";
      this.dblclick = false;
    } else {
      var COUNTRY_CODE = this.screen_details.COUNTRY_CODE.toUpperCase();
      var formData = [
        COUNTRY_CODE,
        this.screen_details.COUNTRY_NAME,
        this.screen_details.CURRENCY_ID
      ];

      if (this.Parent_result_ID != "") {
        var array = {
          parent_table: this.parent_table,
          dbFields: this.dbField,
          parent_table_ID: this.parent_table_ID,
          formData: formData,
          formdataId: this.Parent_result_ID,
          USER_ID: this.uid
        };
        this.vernostService.editData(array).subscribe(response => {
          //   alert(JSON.stringify(response[0].status));
          this.dblclick = false;
          this.forupdate = true;
          //   this.searchForm();
          // this.searchData();

          document.getElementById("errs").innerHTML =
            "Record Updated Successfully";

          this.logService.create_log_masters(
            "'Component Name':Country Master,'Action':Update Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Privious Record':" +
              JSON.stringify(this.previousData) +
              ",'New Record':" +
              JSON.stringify(this.screen_details),
            "info"
          );

          setTimeout(() => {
            document.getElementById("errs").innerHTML = "";
            document.getElementById("errs").style.background = "#ebccd1";
            document.getElementById("errs").style.color = "#a94442";
          }, 5000);
        });
      }
      if (this.Parent_result_ID == "") {
        var Data = {
          parent_table: this.parent_table,
          dbFields: this.dbField,
          formData: formData,
          USER_ID: this.uid,
          PAGENAME: "COUNTRY"
        };

        this.vernostService.insertData(Data).subscribe(response => {
          if (response[0].status == "Failed") {
            document.getElementById("errs").innerHTML = "Invalid data entry";

            setTimeout(function() {
              document.getElementById("errs").innerHTML = "";
            }, 5000);
          } else {
            document.getElementById("errs").innerHTML =
              "Record Created Successfully";

            this.logService.create_log_masters(
              "'Component Name':Country Master,'Action':Create Record,'Modified by':" +
                localStorage.getItem("fname") +
                ",'Record':" +
                JSON.stringify(this.screen_details),
              "info"
            );

            // setTimeout(function() {
            //   document.getElementById("errs").innerHTML = "";
            //   document.getElementById("errs").style.background = "#ebccd1";
            //   document.getElementById("errs").style.color = "#a94442";
            // }, 5000);
            this.dblclick = false;
            this.viewpage = true;
            this.showList = false;
            this.showApprove = true;

            this.showFormData(response[0].addinfo, 1, 1, 1);
          }
        });
      }
    }
  }

  cleanMsg() {
    this.minRemark = false;
  }

  searchData() {
    this.searchlist = false;
    this.loader = true;
    document.getElementById("errs").innerHTML = "";
  
    var fieldone = this.search_details.COUNTRY_CODE;
    var fieldtwo = this.search_details.COUNTRY_NAME;
  
    if (
      (fieldone == "" || fieldone == undefined) &&
      (fieldtwo == "" || fieldtwo == undefined)
    ) {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var fields1 = fieldone.toUpperCase();
      var searchitem = [];
      var searchColumn = [];
      if (fieldone != "" && fieldone != undefined) {
        searchitem.push(fields1);
        searchColumn.push("COUNTRY_CODE");
      }
      if (fieldtwo != "" && fieldtwo != undefined) {
        searchitem.push(fieldtwo);
        searchColumn.push("COUNTRY_NAME");
      }
  
      let dataCountryMaster = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      
      this.vernostService.searchRecords_Country(dataCountryMaster).subscribe(res => {
        this.loader = false;
      
  
        if (res.length > 0) {
          this.searchresult = true;
          this.serachtabledata = res;
          document.getElementById("errs").innerHTML = "";
  
          this.logService.create_log_masters(
            "'Component Name':Country Master,'Action':Srarch Record,'Modified by':" +
              localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.searchresult = false;
          document.getElementById("errs").innerHTML = "Record not found";
        }
      });
    }
  }

  fileChangeListener($event): void {
    this.csvupload.fileChangeListen($event, this.parent_table);
  }

  submitData1() {
    if (
      this.screen_details.COUNTRY_CODE == "" ||
      this.screen_details.COUNTRY_CODE == undefined ||
      this.screen_details.COUNTRY_NAME == "" ||
      this.screen_details.COUNTRY_NAME == undefined ||
      this.screen_details.CURRENCY_ID == undefined ||
      this.screen_details.CURRENCY_ID == "0"
    ) {
      document.getElementById("errs").innerHTML = "Please fill all data";
    } else {
      this.offSubmit = true;
      if (this.actionmode != "Edit") {
        this.checkNames();
      } else {
        this.onEdit_checkName();
      }
    }
  }

  checkNames() {
    if (
      this.screen_details.COUNTRY_CODE != undefined &&
      this.screen_details.COUNTRY_CODE != ""
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "COUNTRY_CODE",
          dbFieldName: this.screen_details.COUNTRY_CODE.toUpperCase(),
          parent_table: this.parent_table
        };

        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist = false;
            if (this.offSubmit) {
              this.checkNames1();
            }
          } else {
            this.nameExist = true;
          }
        });
      }
    }
  }

  onEdit_checkName() {
    if (this.actionmode == "Edit") {
      var code = this.screen_details.COUNTRY_CODE;
      var name = this.screen_details.COUNTRY_NAME;
      var table = this.parent_table;
      var column = "COUNTRY_NAME";
      var column1 = "COUNTRY_CODE";
      let array = {
        code: code,
        name: name,
        table: table,
        column: column,
        column1: column1
      };

      this.vernostService.checkRecordName(array).subscribe(data => {
        if (data[0].status == "success") {
          this.data_present = true;
          this.nameExist1 = true;
        } else {
          this.data_present = false;
          if (this.offSubmit) {
            this.submitdata();
          }
        }
      });
    }
  }

  autoCompleteSearch(event) {
    document.getElementById("errs").innerHTML = "";
    var data = {
      inputSearchString: event,
      parentTableName: this.parentTableName,
      searchDBColumnName: this.searchDBColumnName,
      like: this.like
    };
    if (event.length < 3) {
      this.auto_msg = "";
    }
    if (event.length >= 3) {
      this.vernostService.getRecords(data).subscribe(response => {
        this.formstatusdata = [];
        this.autoArray = response;

        let value = new Array();
        for (let i = 0; i < this.autoArray.length; i++) {
          value[i] = {
            value: this.autoArray[i].COUNTRY_NAME,
            label: this.autoArray[i].COUNTRY_NAME
          };
          this.formstatusdata = value.slice(0);
        }
        if (this.autoArray.length <= 0 && event.length >= 3) {
          this.auto_msg = "No result found";
        } else {
          this.auto_msg = "";
        }
      });
    } else {
      this.formstatusdata = [];
    }
  }

  autoCompleteSearchCurrency(event) {
    var data = {
      inputSearchString: event,
      parentTableName: "mst_currency",
      searchDBColumnName: this.searchDBColumnCurrency,
      like: "CURRENCY_NAME"
    };
    if (event.length >= 3) {
      this.vernostService.getRecords(data).subscribe(response => {
        this.currencydata = [];
        this.autoArray = response;

        let value = new Array();
        for (let i = 0; i < this.autoArray.length; i++) {
          value[i] = {
            value: this.autoArray[i].CURRENCY_ID,
            label: this.autoArray[i].CURRENCY_NAME
          };
          this.currencydata = value.slice(0);
        }
      });
    } else {
      this.currencydata = [];
    }
  }

  searchOnLike() {}

  checkIt(data, flag) {
    this.validateNames(data);
    if (flag == 1) {
      this.checkNames();
    }
  }
  //CODE VALIDATION  STARTS
  validateNames(data) {
    if (data.length == 0) {
      this.minlength = false;
    } else {
      if (data.length < 3) {
        this.minlength = true;
      } else {
        this.minlength = false;
      }
    }
  }

  checkLength(data) {
    this.exceedLength = false;
    this.minlength = false;
    this.notAlphabet = false;
    this.nameExist = false;

    document.getElementById("errs").innerHTML = "";
    // var checkAlphabet = new RegExp("/^[A-Za-z]+$/").test(this.data);
    var regx = /^[A-Za-z]+$/;
    var checkAlphabet = regx.test(data);

    if (this.actionmode == "Edit") {
      this.isApproved = false;
    }

    if (data.length == 0) {
      this.minlength = false;
      this.exceedLength = false;
      this.notAlphabet = false;
    } else {
      if (data.length > 3) {
        this.exceedLength = true;
        this.minlength = false;
      } else {
        this.exceedLength = false;
      }
      if (!checkAlphabet) {
        this.notAlphabet = true;
      } else {
        this.notAlphabet = false;
      }
    }
  }

  checkIt1(data) {
    if (data.length == 0) {
      this.minlength1 = false;
    } else {
      if (data.length < 3) {
        this.minlength1 = true;
      } else {
        this.minlength1 = false;
      }
    }
  }

  checkLength1(data) {
    this.exceedLength1 = false;
    this.minlength1 = false;
    this.notAlphabet1 = false;

    document.getElementById("errs").innerHTML = "";
    // var checkAlphabet = new RegExp("/^[A-Za-z]+$/").test(this.data);
    var regx = /^[A-Za-z]+$/;
    var checkAlphabet = regx.test(data);

    if (data.length == 0) {
      this.minlength1 = false;
      this.exceedLength1 = false;
      this.notAlphabet1 = false;
    } else {
      if (data.length > 3) {
        this.exceedLength1 = true;
        this.minlength1 = false;
      } else {
        this.exceedLength1 = false;
      }
      if (!checkAlphabet) {
        this.notAlphabet1 = true;
      } else {
        this.notAlphabet1 = false;
      }
    }
  }

  //CODE ENDS

  //na

  checkCityName(data) {
    this.nameExist1 = false;
    this.onlyspaces = false;
    this.onlyspclchar = false;
    this.onlynum = false;
    this.data_present = false;
    if (data.length == 0) {
      this.mincityname = false;
      this.cnameExceed = false;
      this.invalidCityName = false;
      this.onlyspaces = false;
    } else {
      if (this.actionmode == "Edit") {
        this.isApproved = false;
      }
      if (data.length >= 2) {
        this.mincityname = false;
      }
      var regx = /^[^-\s][a-zA-Z0-9"!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"\s]{0,125}$/;
      var checkname = regx.test(data);
      if (data.length > 125) {
        this.cnameExceed = true;
      } else {
        this.cnameExceed = false;
        if (!checkname) {
          this.invalidCityName = true;
        } else {
          this.invalidCityName = false;
        }
      }
    }
  }

  onBlurCity(data) {
    // if (this.actionmode != "Edit") {
    //   if (this.nameExist) {
    //     document.getElementById("errs").innerHTML =
    //       "Country code already exist";
    //   }
    //   if (this.nameExist1) {
    //     document.getElementById("errs").innerHTML =
    //       "Country name already exist";
    //   }
    // }
    if (this.actionmode == "Edit") {
      this.onEdit_checkName();
    }
    if (data.length == 0) {
      this.mincityname = false;
      this.onlynum = false;
    } else {
      if (data.length < 3) {
        this.mincityname = true;
      } else {
        this.mincityname = false;
        var regx = /(?!^\d+$)^.+$/;
        var onlyNumber = regx.test(data);

        var space_reg = /^[ ]+$/;
        var onlyspace = space_reg.test(data);
        if (onlyspace) {
          // this.onlyspaces = true;
        }

        if (!onlyNumber) {
          this.onlynum = true;
        } else {
          this.onlynum = false;
        }

        var regsx = /^[!@#$%^&*(),.?":{}|<>]+$/;
        var onlyspecialchar = regsx.test(data);

        if (onlyspecialchar) {
          this.onlyspclchar = true;
        } else {
          this.onlyspclchar = false;
        }
      }
    }
  }

  clearRemark() {
    this.minRemark = false;
    this.aprove_details.APPROVAL_REMARKS = "";
  }
  checkRemarkLength(value) {
    if (value.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }

  getremark(value) {
    this.minRemark = false;
    if (value == undefined || value == "" || value.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }
}
